<!-- Titolo, contenuto e barra azioni sono figli DIRETTI della superficie del
     dialog, che Material dispone come flex column: e' cosi' che il contenuto
     (flex-grow: 1) assorbe lo spazio libero e la fascia panna resta a filo del
     bordo inferiore. Un <div> di raggruppamento qui in mezzo li renderebbe
     figli di un blocco, e il residuo del min-height del pannello si vedrebbe
     come una striscia bianca sotto la fascia. -->
<h2 mat-dialog-title>{{ title }}</h2>

<mat-dialog-content>
  <p class="izy-confirm-message">{{ message }}</p>

  <!-- Conferma obbligatoria in un riquadro a se', come il consenso privacy
       di "Porta un amico": la spunta e' il cancello dell'azione, non una
       riga di testo in mezzo al messaggio. -->
  <div class="izy-confirm-box izy-sharp-bl">
    <mat-checkbox [(ngModel)]="confirmed" color="primary">
      <span class="fw-bold">{{ checkboxLabel }}</span>
    </mat-checkbox>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="izy-dialog-actions">
  <button
    mat-stroked-button
    type="button"
    mat-dialog-close
    class="izy-button-ghost custom-button-border">
    <mat-icon>close</mat-icon>
    Indietro
  </button>

  <!-- Il pulsante che compie l'azione porta il colore dell'azione: rosso pieno
       quando c'e' qualcosa da distruggere, petrol quando la conferma e'
       innocua (il salvataggio di un prodotto). Il resto - etichetta, icona,
       spunta obbligatoria - non cambia. -->
  <button
    mat-raised-button
    matButton="filled"
    type="button"
    class="ms-2 custom-button-border"
    [class.izy-button-danger]="danger"
    [class.izy-button-primary]="!danger"
    [disabled]="!confirmed"
    (click)="confirm()">
    <mat-icon>check</mat-icon>
    Confermo
  </button>
</mat-dialog-actions>
